/**
 * App Router
 *
 * Main routing configuration using React Router.
 * Defines all application routes and their corresponding components.
 */

// src/presentation/router/AppRoutes.tsx

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { routes } from './routes';
import { ProtectedRoute } from './ProtectedRoute';
import DashboardPage from '../pages/dashboard/DashboardPage';
import EquiposPage from '../pages/dashboard/EquiposPage';
import EquipoDetailPage from '../pages/Detail/EquipoDetailPage';
import IncidenteDetailPage from '../pages/Detail/IncidenteDetailPage';
import NuevaUbicacion from '../pages/form/nuevaUbicacion';
import NuevoEquipo from '../pages/form/nuevoEquipoPage';
import NuevoIncidente from '../pages/form/nuevoIncidentePage';
import NuevoSimple from '../pages/form/nuevoSimplePage';
import LoginPage from '../pages/login/loginPage';
import ActionPage from '../pages/action/ActionPage';
import RepuestoPage from '../pages/action/RepuestoPage';
import NewLoginPage from '../pages/login/NewLogin';
import UbicacionDetailPage from '../pages/Detail/UbicacionDetailPage';
import UbicacionesPage from '../pages/dashboard/UbicacionPage';
import VisitasPage from '../pages/dashboard/visitasPage';
import NuevaVisita from '../pages/form/nuevaVisita';
import ActionVisitaPage from '../pages/action/ActionVisitaPage';
import RepuestosCheckPage from '../pages/dashboard/RepuestosCheckPage';


export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path={routes.login} element={<LoginPage />} />
        <Route path={routes.newLogin} element={<NewLoginPage />} />

        <Route
          path={routes.dashboard}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={'/incidentes/formulario/:id?'}
          element={
            <ProtectedRoute>
              <NuevoIncidente />
            </ProtectedRoute>
          }
          />
          <Route
          path={routes.incidenteDetail}
          element={
            <ProtectedRoute>
              < IncidenteDetailPage/>
            </ProtectedRoute>
          }
          
        />
          <Route
            path={routes.equipos}
            element={
              <ProtectedRoute>
                < EquiposPage/>
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.equiposDetail}
            element={
              <ProtectedRoute>
                <EquipoDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
          path={routes.ubicacion}
          element={
            <ProtectedRoute>
              <UbicacionDetailPage />
            </ProtectedRoute>
          }
        />
          <Route
            path={routes.equiposFormulario}
            element={
              <ProtectedRoute>
                <NuevoEquipo />
              </ProtectedRoute>
            }
          />
          <Route
            path={'/simples/:tabla'}
            element={
              <ProtectedRoute>
                <NuevoSimple />
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.ubicacionFormulario}
            element={
              <ProtectedRoute>
                <NuevaUbicacion />
              </ProtectedRoute>
            }
          />
          <Route
            path={routes.actions}
            element={
              <ProtectedRoute>
                <ActionPage />
              </ProtectedRoute>
            }
          />
          <Route
             path={'/repuestos/:id'}
            element={
              <ProtectedRoute>
                <RepuestoPage />
              </ProtectedRoute>
            }
          />
          <Route
             path={routes.ubicaciones}
            element={
              <ProtectedRoute>
                <UbicacionesPage/>
              </ProtectedRoute>
            }
          />
          <Route
             path={routes.visitas}
            element={
              <ProtectedRoute>
                <VisitasPage/>
              </ProtectedRoute>
            }
          />
          <Route
             path={routes.visitaFormulario}
            element={
              <ProtectedRoute>
                <NuevaVisita/>
              </ProtectedRoute>
            }
          />
          <Route
             path={'/visita/:id'}
            element={
              <ProtectedRoute>
                <ActionVisitaPage/>
              </ProtectedRoute>
            }
          />
          <Route
             path={routes.repuestos}
            element={
              <ProtectedRoute>
                <RepuestosCheckPage />
              </ProtectedRoute>
            }
          />

        <Route path="*" element={<Navigate to={routes.notFound} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
